import ServiceContainer from './ServiceContainer';
import ModuleBase from './ModuleBase';

export default ModuleBase(ServiceContainer);
